import { render, staticRenderFns } from "./pipei.vue?vue&type=template&id=58b7592a&scoped=true"
import script from "./pipei.vue?vue&type=script&lang=js"
export * from "./pipei.vue?vue&type=script&lang=js"
import style0 from "./pipei.vue?vue&type=style&index=0&id=58b7592a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b7592a",
  null
  
)

export default component.exports